import { useNavigate } from 'react-router-dom';

import { acceptHealthcareProgramTerms } from 'api/HealthcareProgram';

import { HEALTHCARE_PROGRAM_QUERY_KEY } from 'lib/constants/healthcareProgram/eligibilitySetup';
import { useCustomMutation } from 'lib/hooks/useCustomMutation';

export const useAcceptHealthcareProgramTerms = ({ onSuccess } = {}) => {
  const navigate = useNavigate();

  return useCustomMutation({
    mutationFn: () => acceptHealthcareProgramTerms(navigate, {}),
    successMessage: 'Healthcare Program terms accepted',
    invalidateQueryKey: HEALTHCARE_PROGRAM_QUERY_KEY,
    onSuccess
  });
};
